import React from "react";
import "./search.scss";
import SearchNav from "../SearchNav/SearchNav";

const Search = () => {
  return (
    <div>
     <SearchNav/>
      <div className="input-group mx-auto searchPage-bar">
        <input className="form-control" placeholder="Search" />
        <span className="input-group-text btn-home-search">
          <i className="fa fa-search icon"></i>
        </span>
      </div>
    </div>
  );
};

export default Search;
